export class Agency {
  firstName: string;
  agencyType: string;
  agencyCode: string;
  agencySubType: string;
  codeType: string;
  recommendingOfficerId: string;
  blacklisted: boolean;

  addressLine1: string;
  primaryMobileNumber: number;
  landmark: string;
  secondaryContactNumber: number;
  state: string;
  primaryEmail: string;
  city: string;
  postal_code: string;

  accountHolderName: string;
  bankAccountNo: string;
  bankName: string;
  branchName: string;
  branchCode: string;
  serviceTaxRegistrationNumber: string;

  scopeOfWork: any;

  firstAgreementDate: string;
  lastRenewalDate: string;
  contractExpireDate: string;
  remarks: string;


}



// WEBPACK FOOTER //
// ./src/app/shared/models/agency.model.ts